const enFinancialReport = {
  financialReport: {
    title: 'Financial Reports',

    columns: {
      host: 'Host',
      issuer: 'Issuer',
      month: 'Month',
      quinzena: 'Fortnight',
      customer: 'Customer',
      year: 'Year',
      total: 'Total',
      max_visit_date: 'Last visit',

      subscription_type: 'Subscription type',
      phone: 'Phone',
      email: 'E-mail',
      city: 'City',
      deleted_at: 'Deleted at',
      is_tester: 'Tester',
      balance: 'Balance',
      max_created_at: 'Last movement',

      totalNF: 'Invoice total',
      invoiceDate: 'Invoice date',
      transferDate: 'Transfer date',
      external_transfer_id: 'Transfer ID',
      fileName: 'File',
      externalURL: 'URL',

      yearMonth: 'Year/Month',
      lastMovement: 'Last movement',
      id: 'ID',
      cnpj: 'CNPJ',
      partner: 'Partner',
      serviceProvider: 'Service provider',
      cluster: 'Cluster',
      entradas: 'Income',
      saidas: 'Expenses',
      saldo: 'Balance',

      contract_group_key: 'Index',
      visit_year_month: 'Year/Month',
      max_visit_date_scheduled: 'Last scheduled visit',
      real_estate_name: 'Real estate',
      real_estate_cnpj: 'CNPJ',
      real_estate_date_created: 'Created at',
      real_estate_state: 'State',
      real_estate_city: 'City',
      real_estate_address: 'Address',
      contract_subscription_type: 'Contract type',
      contract_is_active: 'Active contract',
      contract_monthly_capacity: 'Monthly capacity',
      contract_monthly_value: 'Daily value',
      service_contract_area: 'Area (m²)',
      contract_start_date: 'Contract start',
      contract_end_date: 'Contract end',
      agendamentos: 'Appointments',
      payment_amount: 'Payment',
      distinct_realty_code: 'Distinct properties',
      sum_area: 'Total area',
      meses_proporcional: 'Proportional months',

      contract_type: 'Contract type',
      start_date: 'Start date',
      end_date: 'Due date',
      monthly_capacity: 'Monthly volume',
      monthly_value: 'Monthly value',
    },
  },
}

export default enFinancialReport
